class Store {
  imgList = {
    15: [
      '//qnm.hunliji.com/o_1dc3lde951h7i52jeo9h9h1qjeg.png',
      '//qnm.hunliji.com/o_1dc3lde9563f1dbe1jg4124k1sujh.jpg',
      '//qnm.hunliji.com/o_1dc3lde951ek71i9g1dda1tln1e53i.jpg',
      '//qnm.hunliji.com/o_1dc3lde951u1s1mlr1gm2q3b1cuoj.jpg',
      '//qnm.hunliji.com/o_1dc3lde956nu15hl1407qf720jk.jpg',
      '//qnm.hunliji.com/o_1dc3lde951pfr12ph7bpr3vd2il.jpg',
      '//qnm.hunliji.com/o_1dc3lde9512o519fqejk1qj94hm.jpg',
      '//qnm.hunliji.com/o_1dc3lde95qkkk7a1nml1ln74pcn.jpg'
    ],
    14: [
      '//qnm.hunliji.com/o_1dc3lqjfeuj91ehr1dac16q7ue7i.png',
      '//qnm.hunliji.com/o_1dc3lqjfe1rog1rcm168aitt1d3gj.png',
      '//qnm.hunliji.com/o_1dc3lqjfe11otoad12vi1ugovfsk.png',
      '//qnm.hunliji.com/o_1dc3lqjfeqk51ec0g2vnuckrsl.png',
      '//qnm.hunliji.com/o_1dc3lqjfen2k10p05321e26q64m.png',
      '//qnm.hunliji.com/o_1dc3lqjfe15ocjiq1rdj24136un.png',
      '//qnm.hunliji.com/o_1dc3lqjfeqotn481pt81ic81p1so.png',
      '//qnm.hunliji.com/o_1dc3lqjff1qmk1gc0nhu13771riip.png',
      '//qnm.hunliji.com/o_1dc3lqjffsas18511hk31k8c1qv7q.png',
      '//qnm.hunliji.com/o_1dc3lqjff47jru815lv155j6mbr.png'
    ],
    2: [
      '//qnm.hunliji.com/o_1dc3m5vhbgou1lo9tf219p8445g.png',
      '//qnm.hunliji.com/o_1dc3m5vhbbmk1fmj6ns1nq5tn9h.png',
      '//qnm.hunliji.com/o_1dc3m5vhb71r1uchnbm6hc1ji.png',
      '//qnm.hunliji.com/o_1dc3m5vhb14crbekesl1e3k1mv5j.png',
      '//qnm.hunliji.com/o_1dc3m5vhcq2n1bv711dq18p081ak.png',
      '//qnm.hunliji.com/o_1dc3m5vhc1mjjg3dhoun0r1hbnl.png',
      '//qnm.hunliji.com/o_1dc3m5vhc1p19g731flplhu1ebcm.png',
      '//qnm.hunliji.com/o_1dc3m5vhc1b8t1c0oi4rcgr1u2qn.png'
    ],
    9: [
      '//qnm.hunliji.com/o_1dc3majmd1dnp4hipoa2ks1r7mi.png',
      '//qnm.hunliji.com/o_1dc3majmd1a7nppp1gvljmr12elj.png',
      '//qnm.hunliji.com/o_1dc3majmd1t8115n41ftd15fc1sohk.png',
      '//qnm.hunliji.com/o_1dc3majmd1tidv3a1sdi1brbb9l.png',
      '//qnm.hunliji.com/o_1dc3majmd1rn8145m1ehoosd1qhum.png',
      '//qnm.hunliji.com/o_1dc3majmdv9oo9q1oahvtr15r4n.png',
      '//qnm.hunliji.com/o_1dc3majmd19mb1p9h1bhnv6m1vneh.png',
      '//qnm.hunliji.com/o_1dc3majmd1mep90e1lo01lm2t5cg.png'
    ],
    8: [
      '//qnm.hunliji.com/o_1dc3mh3im1bi310d71tuv19ass7ul.png',
      '//qnm.hunliji.com/o_1dc3mh3im7921gmujqe7ll7t3m.png',
      '//qnm.hunliji.com/o_1dc3mh3im7dj1r9eig1kue5h1n.png',
      '//qnm.hunliji.com/o_1dc3mh3imv2o1ncu1qjh1vva1fqpg.png',
      '//qnm.hunliji.com/o_1dc3mh3im1r5g1k1l3s399m1hkth.png',
      '//qnm.hunliji.com/o_1dc3mh3im1u501jg91doh198d8hki.png',
      '//qnm.hunliji.com/o_1dc3mh3im1np31cmb1ra6161e1bm6j.png',
      '//qnm.hunliji.com/o_1dc3mh3immtge5g1lsdb4p1cs3k.png'
    ],
    7: [
      '//qnm.hunliji.com/o_1dc3mn3v8dl31ffb7bmpuc3e2k.png',
      '//qnm.hunliji.com/o_1dc3mn3v81n6j181q5ta1pc9pqal.png',
      '//qnm.hunliji.com/o_1dc3mn3v81u3s1rb11gei1pld1r3qm.png',
      '//qnm.hunliji.com/o_1dc3mn3v84a21o1d12337nd41cn.png',
      '//qnm.hunliji.com/o_1dc3mn3v884r1kd4bqnt1qqlno.png',
      '//qnm.hunliji.com/o_1dc3mn3v8161m1t0knjs1ktlhupp.png',
      '//qnm.hunliji.com/o_1dc3mn3v8ln212j51ouh1qr71hrnq.png',
      '//qnm.hunliji.com/o_1dc3mn3v89ct7jmaa71prc1bgcr.png',
      '//qnm.hunliji.com/o_1dc3mn3v816d539phfq1hnapsns.png',
      '//qnm.hunliji.com/o_1dc3mn3v81q231t821rg21afhe49t.png',
      '//qnm.hunliji.com/o_1dc3mn3v81lsfp0n9ki1n0e1pvdu.png',
      '//qnm.hunliji.com/o_1dc3mn3v8ruq90drf8r43fqev.png'
    ],
    11: [
      '//qnm.hunliji.com/o_1dc3mrman1if81h43r6m6h8g4gk.png',
      '//qnm.hunliji.com/o_1dc3mrman1ppr1643ljrjhs150nl.png',
      '//qnm.hunliji.com/o_1dc3mrman1685ns8bc87581e0um.png',
      '//qnm.hunliji.com/o_1dc3mrman1h2b1eqr1updgomvqn.png',
      '//qnm.hunliji.com/o_1dc3mrmanmodvi112d8e60el6g.png',
      '//qnm.hunliji.com/o_1dc3mrmanq14mql1bo41hji9k7h.png',
      '//qnm.hunliji.com/o_1dc3mrmantnm8vjs9a194iqo9i.png',
      '//qnm.hunliji.com/o_1dc3mrman7tu1tp6146f1prptmgj.png'
    ],
    12: [
      '//qnm.hunliji.com/o_1dc3mvctarrtq3kvks11q6ajtu.png',
      '//qnm.hunliji.com/o_1dc3mvcta1uchgkg112i112pcjgv.png',
      '//qnm.hunliji.com/o_1dc3mvcta1l9315i15fh1jkh136nk.png',
      '//qnm.hunliji.com/o_1dc3mvctapog3qct5pqu2vdol.png',
      '//qnm.hunliji.com/o_1dc3mvcta16f2u991ht7g1l19oqm.png',
      '//qnm.hunliji.com/o_1dc3mvcta1ipq1jp31mbd157m11uun.png',
      '//qnm.hunliji.com/o_1dc3mvcta107n1lu5h3u14qa1tf1o.png',
      '//qnm.hunliji.com/o_1dc3mvctaiio3fl1auj5ad5aip.png',
      '//qnm.hunliji.com/o_1dc3mvcta1r410jb4sg1r9qh0tq.png',
      '//qnm.hunliji.com/o_1dc3mvcta1qn812u6qdnhba1br4r.png',
      '//qnm.hunliji.com/o_1dc3mvctad8l19og8o71stmep1s.png',
      '//qnm.hunliji.com/o_1dc3mvcta173dpqf1vnh1abobiqt.png'
    ],
    6: [
      '//qnm.hunliji.com/o_1dc3n2khp1k6b1s7g6rtejg1h58t.png',
      '//qnm.hunliji.com/o_1dc3n2khp4k669s2cdrg2ihqu.png',
      '//qnm.hunliji.com/o_1dc3n2khp68ng0islojqf115dv.png',
      '//qnm.hunliji.com/o_1dc3n2khor2thv21pblv0m1kflk.png',
      '//qnm.hunliji.com/o_1dc3n2kho1bt11omq11tp1kt71vfdl.png',
      '//qnm.hunliji.com/o_1dc3n2kho1p3lc4n3i8bhicsm.png',
      '//qnm.hunliji.com/o_1dc3n2kho1ge718c91jrkgf51qsmn.png',
      '//qnm.hunliji.com/o_1dc3n2kho1sst7ops9v1p8s1274o.png',
      '//qnm.hunliji.com/o_1dc3n2khoqi613qc1i5s1bpoiu8p.png',
      '//qnm.hunliji.com/o_1dc3n2khp18033g61aue1g4i1da1q.png',
      '//qnm.hunliji.com/o_1dc3n2khpn15cttluf1lqm188jr.png',
      '//qnm.hunliji.com/o_1dc3n2khp154f1jiuujuu21vifs.png'
    ]
  }
}

export default Store
